// Use this file to store any shared constants that will be used multiple times
export const Constants = {
  Amazon_A_to_Z: "Amazon A to Z",
  atoz_web_prod_url: "https://atoz.amazon.work"
} as const;

export default Constants;
